import { useCallback, useEffect, useState } from "react";
import { RoutePermissionFunction } from "router-manager/parts";
import { Toast } from "components/toast";
import {
  ModelosPipelineEndpoints,
  PipelineModeloDTO
} from "components/modelos-pipeline-components/utils";
import { ModelosListView } from "components/modelos-pipeline-components/modelos-list-view";
import { ModeloFormView } from "components/modelos-pipeline-components/modelo-form-view";

type PageView = "LIST" | "FORM";

export default function ModelosPipeline() {
  const [view, setView] = useState<PageView>("LIST");
  const [editingModelo, setEditingModelo] = useState<
    PipelineModeloDTO | undefined
  >();
  const [modelos, setModelos] = useState<PipelineModeloDTO[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadModelos = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await ModelosPipelineEndpoints.list();
      setModelos(data);
    } catch {
      Toast({ title: "Erro ao carregar modelos", status: "error" });
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadModelos();
  }, [loadModelos]);

  const handleNew = () => {
    setEditingModelo(undefined);
    setView("FORM");
  };

  const handleEdit = (m: PipelineModeloDTO) => {
    setEditingModelo(m);
    setView("FORM");
  };

  const handleBack = () => {
    setView("LIST");
    setEditingModelo(undefined);
  };

  const handleSaved = () => {
    setView("LIST");
    setEditingModelo(undefined);
    loadModelos();
  };

  const handleDeleted = (id: number) => {
    setModelos((prev) => prev.filter((m) => m.id !== id));
  };

  const handleStatusToggled = (updated: PipelineModeloDTO) => {
    setModelos((prev) => prev.map((m) => (m.id === updated.id ? updated : m)));
  };

  if (view === "FORM") {
    return (
      <ModeloFormView
        editingModelo={editingModelo}
        onBack={handleBack}
        onSaved={handleSaved}
      />
    );
  }

  return (
    <ModelosListView
      modelos={modelos}
      isLoading={isLoading}
      onNew={handleNew}
      onEdit={handleEdit}
      onDeleted={handleDeleted}
      onStatusToggled={handleStatusToggled}
    />
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission(["SUPER", "PARCEIRO_MASTER"]);
  route.addCustomPermission(
    (user) => user?.userData.customerId === 1 && user.isLogged
  );
};
